<template>
  <FeedbackStep :title="title" :number="number">
    <template v-slot:content>
      <div class="feedback-form">
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q6AnswerYes"
            type="radio"
            name="q6Answer"
            value="tak"
            v-model.trim="form.answer_q6"
            @input="delayTouch($v.form.answer_q6)"
            @click="hasDescription = false"
          />
          <label for="q6AnswerYes" class="form__label">tak</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q6AnswerNo"
            type="radio"
            name="q6Answer"
            value="nie"
            v-model.trim="form.answer_q6"
            @input="delayTouch($v.form.answer_q6)"
            @click="hasDescription = false"
          />
          <label for="q6AnswerNo" class="form__label">nie</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q6AnswerOther"
            type="radio"
            name="q6Answer"
            value="inna odpowiedź"
            v-model.trim="form.answer_q6"
            @input="delayTouch($v.form.answer_q6)"
            @change="otherHandler"
          />
          <label for="q6AnswerOther" class="form__label">inna odpowiedź</label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasDescription"
            class="form__input-wrapper"
            :class="{ error: $v.form.answer_q6_content.$anyError }"
          >
            <label for="answer_q6_content" class="form__label uk-hidden"
              >Podaj inne</label
            >
            <input
              class="form-input uk-width-1-1"
              id="answer_q6_content"
              type="text"
              name="answer_q6_content"
              ref="otherInput"
              @input="event => delayTouchCounterComposition(
                $v.form,
                'answer_q6_content',
                event.target.value
              )"
            />
            <span class="form__error-message form__error-message--no-label">
              <template v-if="!$v.form.answer_q6_content.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.answer_q6_content.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
      </div>
    </template>
  </FeedbackStep>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import FeedbackStep from '../global/FeedbackStep.vue';

export default {
  name: 'Question6',
  components: { FeedbackStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Czy te wyjaśnienia były wystarczające?',
    number: 6,
    form: {
      answer_q6: null,
      answer_q6_content: '',
    },
    hasDescription: false,
  }),
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          answer_q6: {
            required,
          },
        },
      };
    }
    return {
      form: {
        answer_q6: {
          required,
        },
        answer_q6_content: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  methods: {
    otherHandler() {
      this.hasDescription = true;
      this.form.answer_q6_content = '';

      if (!this.hasDescription) {
        this.form.answer_q6_content = '';
      } else {
        setTimeout(() => {
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
  },
};
</script>
